import zhCN from './zh-CN.json';
import en from './en.json';
import de from './de.json';
import es from './es.json';
import fr from './fr.json';
import it from './it.json';
import ja from './ja.json';
import ko from './ko.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import id from './id.json';

const LEGAL_BY_LOCALE = {
  'zh-CN': zhCN,
  en,
  de,
  es,
  fr,
  it,
  ja,
  ko,
  'pt-BR': ptBR,
  th,
  vi,
  id,
};

/** 法务正文随界面语言切换；未知语言回退英文。 */
export function getLegalContent(language) {
  const raw = String(language || 'zh-CN').trim();
  const lower = raw.toLowerCase();
  if (lower.startsWith('zh')) return LEGAL_BY_LOCALE['zh-CN'];
  if (lower === 'pt-br' || lower.startsWith('pt')) return LEGAL_BY_LOCALE['pt-BR'];
  if (LEGAL_BY_LOCALE[raw]) return LEGAL_BY_LOCALE[raw];
  const base = lower.split('-')[0];
  const hit = Object.keys(LEGAL_BY_LOCALE).find((key) => key.toLowerCase() === lower || key.toLowerCase().startsWith(`${base}-`) || key.toLowerCase() === base);
  if (hit) return LEGAL_BY_LOCALE[hit];
  return LEGAL_BY_LOCALE.en;
}

export function getLegalDoc(language, kind) {
  const pack = getLegalContent(language);
  const doc = kind === 'privacy' ? pack.privacy : pack.terms;
  return {
    updateDate: pack.updateDate,
    chrome: pack.chrome,
    ...doc,
  };
}
